// Native play events (including Safari controls) enforce one audible surface.
export function pauseOtherAudio(event) {
  document.querySelectorAll('audio').forEach(audio => {
    if (audio !== event.currentTarget && !audio.paused) audio.pause();
  });
}
export function releaseAudio(audio) {
  if (!audio) return;
  audio.pause();
  audio.removeAttribute('src');
  audio.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
  audio.load();
}
